const galleries = document.querySelectorAll(".light-gallery");

if (galleries.length) {
  galleries.forEach((gallery) => {
    lightGallery(gallery, {
      speed: 500,
      selector: ".gallery-item",
    });
  });
}
